import { StatCard } from '@/common/dashboard/StatCard';
import { Spacer } from '@/common/layout/SpacerLayout';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { useEffect, useState } from 'react';

export const ChbkFinGrowthCards = ({ formValues, totalValues }) => {

  let { chbkPeriodId, chbkDate, distCustIds, ctrtIds, prodIds, agg } = formValues;

  const { totalProdIds, totalDistCustIds, totalCtrtIds } = totalValues;

  const rsrc = useRsrc();
  const [data, setData] = useState();

  useEffect(() => {
    if (!chbkPeriodId && !chbkDate) {
        return;
    }

    let prodIdsNot = true;
    if (totalProdIds.length / 2 < prodIds.length) {
      prodIds = totalProdIds.filter(id => !prodIds.includes(id));
    } else {
      prodIdsNot = false;
    }

    let distCustIdsNot = true;
    if (totalDistCustIds.length / 2 < distCustIds.length) {
      distCustIds = totalDistCustIds.filter(id => !distCustIds.includes(id));
    } else {
      distCustIdsNot = false;
    }

    let ctrtIdsNot = true;
    if (totalCtrtIds.length / 2 < ctrtIds.length) {
      ctrtIds = totalCtrtIds.filter(id => !ctrtIds.includes(id));
    } else {
      ctrtIdsNot = false;
    }

    const reqParam = {
      periodId: chbkPeriodId,
      chbkDate,
      distCustIds,
      distCustIdsNot,
      ctrtIds,
      ctrtIdsNot,
      prodIds,
      prodIdsNot,
      agg
    };

    rsrc.data('sc', 'CHBK_FIN_GROWTH_CARDS_DATA_PLUGIN', reqParam).then(res => {
      setData(res);
    });
  }, [chbkPeriodId, chbkDate, distCustIds, ctrtIds, prodIds, agg]);

  return (
    <Spacer>
      <Spacer vertical>
        <StatCard
          title="Largest YoY Distributor Decrease"
          flex={1}
          val={data?.largestDistCustAmtDecrease}
          isAmt={agg === 'PAID_AMT'}
          pctChange={data?.largestDistCustPctDecrease === 0 ? null : data?.largestDistCustPctDecrease}
          vsLabel={data?.priorPeriodCode}
          label={data?.distCustName}
        />
        <StatCard
          title="Largest YoY Brand Decrease"
          flex={1}
          val={data?.largestBrandAmtDecrease}
          isAmt={agg === 'PAID_AMT'}
          pctChange={data?.largestBrandPctDecrease === 0 ? null : data?.largestBrandPctDecrease}
          vsLabel={data?.priorPeriodCode}
          label={data?.brandCode}
        />
        {/* <StatCard
          title="Largest YoY Contract Decrease"
          flex={1}
          val={data?.largestCtrtAmtDecrease}
          isAmt={agg === 'PAID_AMT'}
          pctChange={data?.largestCtrtPctDecrease}
          vsLabel={data?.priorPeriodCode}
          label={data?.ctrtType}
        /> */}
      </Spacer>
    </Spacer>
  )

}